export enum Platform {
    UNKNOWN = 'UNKNOWN',
    // Web Based
    EDITOR_PAGE = 'EDITOR_PAGE',
    EDITOR_CORE = 'EDITOR_CORE',
    MOBILE_BROWSER = 'MOBILE_BROWSER',
    DESKTOP_BROWSER = 'DESKTOP_BROWSER',
    // Native
    WIN32 = 'WIN32',
    ANDROID = 'ANDROID',
    IOS = 'IOS',
    MACOS = 'MACOS',
    OHOS = 'OHOS',
    // Minigame
    WECHAT_GAME = 'WECHAT_GAME',
    BAIDU_MINI_GAME = 'BAIDU_MINI_GAME',
    XIAOMI_QUICK_GAME = 'XIAOMI_QUICK_GAME',
    ALIPAY_MINI_GAME = 'ALIPAY_MINI_GAME',
    TAOBAO_CREATIVE_APP = 'TAOBAO_CREATIVE_APP',
    BYTEDANCE_MINI_GAME = 'BYTEDANCE_MINI_GAME',
    // Runtime Based
    OPPO_MINI_GAME = 'OPPO_MINI_GAME',
    VIVO_MINI_GAME = 'VIVO_MINI_GAME',
    HUAWEI_QUICK_GAME = 'HUAWEI_QUICK_GAME',
    COCOSPLAY = 'COCOSPLAY',
    LINKSURE_MINI_GAME = 'LINKSURE_MINI_GAME',
    QTT_MINI_GAME = 'QTT_MINI_GAME',
}
